import { InjectionToken } from "@angular/core";
import { StaffBenefitRequestsPort } from "./staff-benefit-requests.port";

export const STAFF_BENEFIT_REQUESTS_PORT =
  new InjectionToken<StaffBenefitRequestsPort>("STAFF_BENEFIT_REQUESTS_PORT");
